<template>
    <div class="dataListContainer">
        <div class="row" v-for="item in datalist" :key="item">
            <div class="leftSide">{{ item.label }}</div>
            <div v-if="item.value?.tableHeader" class="rightSide">
                <DataTable
                    class="datatable"
                    :tableHeader="item.value.tableHeader"
                    :noDataText="item.value.noDataText"
                    :tableData="item.value.tableData"
                    :stop-propa-on-pdf="stopPropaOnPdf"
                    @select="emitSelect"
                    @downloadPdf="emitDownload"
                />
            </div>
            <div v-else-if="item.value?.linkText" class="rightSide">
                <a
                    :download="item.value.linkText"
                    :href="item.value.link"
                    :class="item.value.link === '' && 'disabled'"
                    target="_blank"
                >
                    {{ item.value.linkText }}
                </a>
            </div>
            <div v-else-if="item.value?.pj" class="rightSide">
                <AttachmentList :data="item.value.pjs" :action="item.value.action" />
            </div>
            <div v-else-if="item.value?.pdfExist" class="rightSide" @click="emitDownload">
                <img class="pdf-icon" :src="pdfIcon" alt="pdf download-pdf" />
            </div>
            <router-link
                class="rightSide"
                v-else-if='item.value?.pageGoTo'
                :to="{ name: item.value?.pageGoTo, params: { id: item.value.id } }"
            >
                {{ item.value.id ?? '' }}
            </router-link>
            <div v-else class="rightSide">{{ item.value ?? '' }}</div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import AttachmentList from './AttachmentList.vue';
import DataTable from './DataTable.vue';

export default defineComponent({
    name: 'DataList',
    props: {
        data: { type: Array as PropType<any>, required: true },
        stopPropaOnPdf: { type: Boolean, required: false },
    },
    components: { DataTable, AttachmentList },
    computed: {
        datalist(): any {
            return this.data.filter((i: { value: string | any[]; }) => (Array.isArray(i.value) ? i.value.length > 0 : !!i.value));
        },
        pdfIcon() {
            return require('@/assets/img/pdf-icon.svg');
        },
    },
    methods: {
        emitSelect(item: any) : void {
            this.$emit('select', item);
        },
        emitDownload(item: any) : void {
            this.$emit('downloadPdf', item);
        },
    }
});
</script>

<style scoped>
.dataListContainer {
    border: 1px solid var(--white);
    background: white;
    border-radius: 6px;
    margin-bottom: 8px;
    margin-top: 16px;
}
.row {
    display: flex;
    width: 100%;
}
.row:first-child .leftSide {
    border-top-left-radius: 6px;
}
.row:last-child .leftSide {
    border-bottom-left-radius: 6px;
}
.row:last-child .rightSide {
    padding-bottom: 20px;
}
.leftSide {
    display: flex;
    align-items: center;
    padding: 4px 20px;
    min-height: 30px;
    background-color: var(--color-principal-transparent);
    text-align: end;
    width: 33%;
}
.rightSide {
    display: flex;
    align-items: center;
    min-height: 30px;
    padding: 4px 20px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
}
.disabled {
    cursor: not-allowed;
}
.pdf-icon{
    cursor: pointer;
}
</style>
